module.exports = __webpack_public_path__ + "static/assets/59428ca5b48ecdf60132ddbc82baaa4a.svg";